import { createContext, useContext } from 'react';
import type { IAssistantContext } from '../interfaces/IAssistantContext';

export const AssistantContext = createContext<IAssistantContext | null>(null);

export const useAssistantContextValue = (): IAssistantContext => {
  const context = useContext(AssistantContext);
  if (!context) {
    throw new Error('useAssistantContextValue must be used within AssistantPanelProvider');
  }
  return context;
};
